import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import HeaderStyles from 'components/admin/businesses/devices/Header.module.scss';
import { ReactComponent as UploadIcon } from 'assets/images/icon_upload.svg';
import { UploadDeviceCsvModal } from './UploadDeviceCsvModal';

export function Header({ businessOwner, refetchBatches, batchCount, reinitializeDevices, stores }) {
  const { id: businessOwnerId } = useParams();
  const [isUploadDeviceModalOpen, setIsUploadDeviceModalOpen] = useState(false);

  const batchCountText = `Batches Assigned: ${businessOwner?.batchCount ?? 0}`;
  const totalDevicesText = `Total Devices: ${businessOwner?.deviceCount ?? 0}`;

  return (
    <div className={HeaderStyles.headerContainer}>
      <div className={HeaderStyles.deviceCustomerDetailsContainer}>
        <div className={HeaderStyles.deviceCounts}>
          <span>{batchCountText}</span>
          <span>{totalDevicesText}</span>
        </div>
        <div className={HeaderStyles.deviceButtons}>
          <button
            className={HeaderStyles.uploadDeviceIds}
            onClick={() => setIsUploadDeviceModalOpen(true)}
          >
            <UploadIcon />
            <span>Upload Device Ids</span>
          </button>
          {batchCount > 0 && (
            <button
              className={HeaderStyles.uploadDeviceIds}
              onClick={reinitializeDevices}
            >
              Reinitialize Devices
            </button>
          )}
        </div>
      </div>
      {isUploadDeviceModalOpen && (
        <UploadDeviceCsvModal
          businessId={businessOwnerId}
          onClose={() => {
            setIsUploadDeviceModalOpen(false);
          }}
          refetchBatches={refetchBatches}
          stores={stores}
        />
      )}
    </div>
  );
}

Header.propTypes = {
  businessOwner: PropTypes.shape({
    batchCount: PropTypes.number.isRequired,
    businessid: PropTypes.number,
    deviceCount: PropTypes.number.isRequired,
    firstname: PropTypes.string.isRequired,
    lastname: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    userId: PropTypes.number.isRequired,
  }),
  refetchBatches: PropTypes.func.isRequired,
  batchCount: PropTypes.number.isRequired,
  reinitializeDevices: PropTypes.func.isRequired,
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ).isRequired,
};
